import React from 'react'
import { Video } from '../../common';

function VideoElement({ track, className = '' }) {
    let videoTrack = { jitsiTrack: track };

    return (
        <>
            <Video
                key={`video_${track.getId()}`}
                id={`video_${track.getId()}`}
                videoTrack={videoTrack}
                className={className}
            />
        </>
    );
}

export default VideoElement